module.exports = __webpack_public_path__ + "img/sharp-logo.29128970.png";